/* eslint-disable react/prop-types */
import ModalUI from "components/ModalUI";
import * as React from "react";

export default function InvestmentOpportunityDetailModal({ modalInfo, closeModal }) {
    const data = modalInfo.item
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px", fontSize: 16 }}>
            <p style={{ marginBottom: 5 }}>آماده سرمایه گذاری: {data.is_open ? "بله" : "خیر"}</p>
            <p style={{ marginBottom: 5 }}>فعال: {data.is_active ? "بله" : "خیر"}</p>
            <p style={{ marginBottom: 5 }}>قفل: {data.locked ? "بله" : "خیر"}</p>
            <p style={{ marginBottom: 5 }}>بازه تقسیم سود: {data.profit_period_name}</p>
            <p style={{ marginBottom: 5 }}>زمان شروع سرمایه گذاری: {data.investment_started_at}</p>
        </ModalUI>
    );
}
